// extracted by mini-css-extract-plugin
export var inline = "MetaList-module--inline--iNCPw";
export var root = "MetaList-module--root--RLuwV";